/**
 * Decode the JWT `exp` claim and report whether it has passed. The impersonation
 * token is signed server-side with a 24h expiry; once it lapses the server rejects
 * it. We check it client-side so a dead token is never even sent — otherwise the
 * server silently falls back to the real admin while the impersonation banner still
 * shows. This only reads the (unverified) payload; the server remains the authority
 * on validity. On any decode failure we return false and let the server decide.
 */
export function isImpersonationTokenExpired(token: string): boolean {
  try {
    const payloadSegment = token.split('.')[1];
    if (!payloadSegment) return false;
    const json = atob(payloadSegment.replace(/-/g, '+').replace(/_/g, '/'));
    const payload = JSON.parse(json) as { exp?: unknown };
    return typeof payload.exp === 'number' && payload.exp * 1000 < Date.now();
  } catch {
    return false;
  }
}
